import { FormConditionalValidation } from '../typings';

export const generateConditionalValidation = (
  conditions: FormConditionalValidation[],
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  values: any[],
): boolean => {
  return conditions
    .map((condition, index) => {
      switch (condition.type) {
        case 'question-with-details':
          return values[index] === condition.on;
        case 'should-validate':
          return values[index] === true;
        case 'not-applicable':
          return values[index] === true;
        case 'match':
          return values[index] === condition.value;
        case 'instance-has-value':
          return values[index] === true;
      }
    })
    .every(condition => condition);
};
